import { defineStore } from 'pinia';

export const useDevelopmentDocsStore = defineStore('developmentDocs', {
  state: () => ({
    selectedDocs: []
  }),
  actions: {
    setSelectedDocs(docs) {
      this.selectedDocs = docs;
    },
    clearSelectedDocs() {
      this.selectedDocs = [];
    }
  }
}); 